import { useEffect } from "react";
import BabyGrowIcon from '../images/baby-grow-icon.png';

function AboutUsPage() {
  
  useEffect(() => {
    window.scrollTo(0, 0);
  },[]);

  return (
    <div className="page about-us-page">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <h2>About Elysian Creative Designs</h2>
            <img src={BabyGrowIcon} alt="icon" style={{maxHeight: '50px', rotate: '0deg', marginBottom: '20px'}}/>
          </div>
          <div className="col-0 col-sm-3"></div>
          <div className="col-12 col-sm-6">
            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutUsPage;
